export default {
    computed: {
        scoreTypeList () {
            const projectId = this.$store.state.user.projectId + ''
            if(projectId === '2') {
                return this.selectMap.WB_SCORE_TYPE
            }
            return (this.selectMap.WB_SCORE_TYPE || []).filter(st => !['11', '12', '13'].includes(st.value))
        },
        selectMap () {
            return this.$store.state.baseData.selectMap
        },
        salaryMap () {
            return this.$store.state.salary.selectMap
        }
    },
    methods: {
        ajaxGetSelectMap (key) {
            return this.$axios.get('/share/getBasicData.api?BASE_DATA_KEY=' + key)
        },
        /**
         * 根据value值来获取基础映射数据的text值
         * @param selectMapName ：基础映射的list数组
         * @param value   : 对应的value值
         * @returns {string}
         */
        getSelectMapText (selectMapName, value, separator = '') {
            let text = '', // 也可以传入数组
                list = selectMapName instanceof Array ? selectMapName : this.selectMap[selectMapName],
                curValue = '',
                resultTxt = []
            if (!(value instanceof Array)) {
                value = [value]
            }
            curValue = value.shift()
            while (typeof curValue !== 'undefined' && list) {
                for (let index = 0; index < list.length; index++) {
                    let item = list[index]
                    if (item.value === String(curValue)) {
                        resultTxt.push(item.text)
                        list = item.list
                        break
                    }
                }
                curValue = value.shift()
            }
            return (resultTxt.length === 1 ? resultTxt[0] : resultTxt.join(separator))
        },
        getSalaryMap (selectMapName) {
            console.log('getSalary')
            return selectMapName instanceof Array ? selectMapName : this.salaryMap[selectMapName]
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/selectMapMixin.js